// import { useState, useEffect } from 'react' // マップ機能一時非表示
import { Card, CardContent, CardHeader, CardTitle } from '@creanizer/ui'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@creanizer/ui'
import { Button } from '@creanizer/ui'
import { Copy } from 'lucide-react'
// import { Map } from 'lucide-react' // マップ機能一時非表示
import type { DungeonResult as DungeonResultType } from '@creanizer/types'
// import type { DungeonMapData } from '@creanizer/types' // マップ機能一時非表示
// import { DungeonMapCanvas } from './DungeonMapCanvas' // マップ機能一時非表示
// import { useDungeonStore } from '../../../../stores/dungeonStore' // マップ機能一時非表示

interface DungeonResultProps {
  results: DungeonResultType[]
  mode: string
  dungeonId?: string // 保存済みダンジョンのID
  // savedMapData?: Record<number, DungeonMapData> // マップ機能一時非表示
}

export function DungeonResult({ results, mode, dungeonId }: DungeonResultProps) { // savedMapDataを削除
  // const [selectedFloorIndex, setSelectedFloorIndex] = useState(0) // マップ機能一時非表示
  // const { updateDungeonMapData } = useDungeonStore() // マップ機能一時非表示
  
  // // resultsが変更されたらselectedFloorIndexをリセット - マップ機能一時非表示
  // useEffect(() => {
  //   setSelectedFloorIndex(0)
  // }, [results])
  
  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text)
  }
  
  const handleCopyAll = (result: DungeonResultType) => {
    navigator.clipboard.writeText(JSON.stringify(result, null, 2))
  }
  
  // const handleMapGenerated = (mapData: DungeonMapData) => { // マップ機能一時非表示
  //   // 保存済みダンジョンの場合、マップデータを保存
  //   if (dungeonId) {
  //     updateDungeonMapData(dungeonId, selectedFloorIndex, mapData)
  //   }
  // }
  
  if (results.length === 0) return null
  
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">生成結果</h2>
      
      {results.map((result, index) => (
        <Card key={index}>
          <CardHeader>
            <CardTitle className="flex justify-between items-center">
              <span>{result.basicInfo?.name || '名称不明'}</span>
              <Button
                size="sm"
                variant="outline"
                onClick={() => handleCopyAll(result)}
              >
                <Copy className="h-4 w-4 mr-2" />
                全体をコピー
              </Button>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <Tabs defaultValue="basic">
              <TabsList className="grid w-full grid-cols-4">
                <TabsTrigger value="basic">基本情報</TabsTrigger>
                <TabsTrigger value="structure">構造</TabsTrigger>
                {/* <TabsTrigger value="map">マップ</TabsTrigger> */}
                <TabsTrigger value="contents">コンテンツ</TabsTrigger>
                <TabsTrigger value="anecdotes">逸話</TabsTrigger>
              </TabsList>
              
              <TabsContent value="basic" className="space-y-4">
                <div>
                  <h3 className="font-semibold">名前</h3>
                  <p>{result.basicInfo?.name || '名称不明'}</p>
                  {Array.isArray(result.basicInfo.aliases) && result.basicInfo.aliases.length > 0 && (
                    <p className="text-sm text-muted-foreground">
                      別名: {result.basicInfo.aliases.join(', ')}
                    </p>
                  )}
                </div>
                
                <div>
                  <h3 className="font-semibold">タイプ</h3>
                  <p>{result.basicInfo?.type || '不明'}</p>
                </div>
                
                <div>
                  <h3 className="font-semibold">難易度</h3>
                  <p>{result.basicInfo?.difficulty || '不明'}</p>
                </div>
                
                <div>
                  <h3 className="font-semibold">概要</h3>
                  <p>{result.basicInfo?.summary || '説明なし'}</p>
                </div>
                
                <div>
                  <h3 className="font-semibold">説明</h3>
                  <p className="whitespace-pre-wrap">{result.basicInfo?.description || '詳細不明'}</p>
                </div>
                
                <div>
                  <h3 className="font-semibold">第一印象</h3>
                  <p>{result.basicInfo?.firstImpression || '特になし'}</p>
                </div>
                
                {result.basicInfo.features && (
                  <div>
                    <h3 className="font-semibold">特徴</h3>
                    <p className="whitespace-pre-wrap">{result.basicInfo.features}</p>
                  </div>
                )}
              </TabsContent>
              
              <TabsContent value="structure" className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <h3 className="font-semibold">総部屋数</h3>
                    <p>{result.structure?.totalRooms || 0}部屋</p>
                  </div>
                  
                  <div>
                    <h3 className="font-semibold">フロア数</h3>
                    <p>{Array.isArray(result.structure?.floors) ? result.structure.floors.length : 0}フロア</p>
                  </div>
                </div>
                
                <div>
                  <h3 className="font-semibold">レイアウト</h3>
                  <p className="font-medium">{result.structure?.layout?.type || '不明'}</p>
                  <p className="text-sm text-muted-foreground mt-1">
                    {result.structure?.layout?.description || '説明なし'}
                  </p>
                </div>
                
                {/* フロア詳細 */}
                {Array.isArray(result.structure?.floors) && result.structure.floors.map((floor, floorIndex) => (
                  <div key={floorIndex} className="mt-6 p-4 border rounded-lg">
                    <h4 className="font-semibold text-lg mb-3">
                      {floor.name || `第${floor.level}フロア`}
                    </h4>
                    
                    <div className="mb-4">
                      <p className="text-sm font-medium mb-1">テーマ</p>
                      <p className="text-sm text-muted-foreground">{floor.theme}</p>
                    </div>
                    
                    <div className="mb-4">
                      <p className="text-sm font-medium mb-1">雰囲気</p>
                      <p className="text-sm whitespace-pre-wrap">
                        {typeof floor.ambiance === 'string' 
                          ? floor.ambiance 
                          : (floor.ambiance as any)?.description || JSON.stringify(floor.ambiance)}
                      </p>
                    </div>
                    
                    {/* 部屋リスト */}
                    <div className="space-y-4">
                      <h5 className="font-medium">部屋 ({floor.rooms?.length || 0}室)</h5>
                      {Array.isArray(floor.rooms) && floor.rooms.map((room, roomIndex) => (
                        <div key={roomIndex} className="ml-4 p-3 bg-muted/50 rounded">
                          <div className="flex justify-between items-start mb-2">
                            <h6 className="font-medium">
                              {room.name || `部屋${roomIndex + 1}`}
                            </h6>
                            {room.isImportant && (
                              <span className="text-xs bg-primary text-primary-foreground px-2 py-1 rounded">
                                重要
                              </span>
                            )}
                          </div>
                          
                          <p className="text-sm whitespace-pre-wrap">
                            {room.description}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
                
                {/* 移動・接続空間 */}
                {Array.isArray(result.structure?.transitSpaces) && result.structure.transitSpaces.length > 0 && (
                  <div className="mt-6">
                    <h4 className="font-semibold text-lg mb-4">移動・接続空間</h4>
                    <div className="space-y-4">
                      {result.structure.transitSpaces.map((transit, transitIndex) => (
                        <div key={transitIndex} className="p-4 border rounded-lg bg-muted/30">
                          <div className="flex justify-between items-start mb-2">
                            <h5 className="font-medium text-base">
                              {transit.name || `移動空間${transitIndex + 1}`}
                            </h5>
                            <div className="flex gap-2">
                              <span className="text-xs bg-secondary text-secondary-foreground px-2 py-1 rounded">
                                {transit.type || '通路'}
                              </span>
                              <span className="text-xs bg-secondary text-secondary-foreground px-2 py-1 rounded">
                                第{transit.floor || 1}フロア
                              </span>
                            </div>
                          </div>
                          
                          <div className="space-y-2">
                            <div>
                              <p className="text-sm font-medium mb-1">説明</p>
                              <p className="text-sm text-muted-foreground whitespace-pre-wrap">
                                {transit.description || '詳細不明'}
                              </p>
                            </div>
                            
                            {transit.hazards && (
                              <div>
                                <p className="text-sm font-medium mb-1">危険要素</p>
                                <p className="text-sm text-destructive whitespace-pre-wrap">
                                  {transit.hazards}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </TabsContent>
              
              {/* マップ機能は一時的に非表示 */}
              {/* <TabsContent value="map" className="space-y-4">
                {Array.isArray(result.structure?.floors) && result.structure.floors.length > 0 ? (
                  <div className="space-y-4">
                    <div className="flex space-x-2 overflow-x-auto pb-2">
                      {result.structure.floors.map((floor, index) => (
                        <Button
                          key={index}
                          variant={selectedFloorIndex === index ? 'default' : 'outline'}
                          onClick={() => setSelectedFloorIndex(index)}
                          className="min-w-[100px]"
                        >
                          {floor.name || `B${floor.level}F`}
                        </Button>
                      ))}
                    </div>
                    
                    <DungeonMapCanvas 
                      floor={result.structure.floors[selectedFloorIndex]} 
                      floorIndex={selectedFloorIndex}
                      dungeonId={dungeonId}
                      savedMapData={savedMapData?.[selectedFloorIndex]}
                      onMapGenerated={handleMapGenerated}
                    />
                  </div>
                ) : (
                  <div className="text-center text-muted-foreground py-8">
                    <Map className="h-12 w-12 mx-auto mb-2 opacity-50" />
                    <p>フロアデータがありません</p>
                  </div>
                )}
              </TabsContent> */}
              
              <TabsContent value="contents" className="space-y-4">
                {result.contents.enemies && (
                  <div>
                    <h3 className="font-semibold mb-2">敵</h3>
                    <p className="whitespace-pre-wrap">{result.contents.enemies}</p>
                  </div>
                )}
                
                {result.contents.bosses && (
                  <div>
                    <h3 className="font-semibold mb-2">ボス</h3>
                    <p className="whitespace-pre-wrap">{result.contents.bosses}</p>
                  </div>
                )}
                
                {result.contents.puzzles && (
                  <div>
                    <h3 className="font-semibold mb-2">パズル</h3>
                    <p className="whitespace-pre-wrap">{result.contents.puzzles}</p>
                  </div>
                )}
                
                {result.contents.traps && (
                  <div>
                    <h3 className="font-semibold mb-2">トラップ</h3>
                    <p className="whitespace-pre-wrap">{result.contents.traps}</p>
                  </div>
                )}
                
                {result.contents.treasures && (
                  <div>
                    <h3 className="font-semibold mb-2">宝物</h3>
                    <p className="whitespace-pre-wrap">{result.contents.treasures}</p>
                  </div>
                )}
              </TabsContent>
              
              <TabsContent value="anecdotes" className="space-y-4">
                {result.anecdotes && (
                  <div className="space-y-4">
                    {result.anecdotes.historyAndLore && (
                      <div>
                        <h3 className="font-semibold mb-2">歴史と伝承</h3>
                        <p className="whitespace-pre-wrap">{result.anecdotes.historyAndLore}</p>
                      </div>
                    )}
                    
                    {result.anecdotes.rumors && (
                      <div>
                        <h3 className="font-semibold mb-2">噂話</h3>
                        <p className="whitespace-pre-wrap">{result.anecdotes.rumors}</p>
                      </div>
                    )}
                    
                    {result.anecdotes.events && (
                      <div>
                        <h3 className="font-semibold mb-2">過去の出来事</h3>
                        <p className="whitespace-pre-wrap">{result.anecdotes.events}</p>
                      </div>
                    )}
                    
                    {result.anecdotes.hiddenStory && (
                      <div>
                        <h3 className="font-semibold mb-2">隠された物語</h3>
                        <p className="whitespace-pre-wrap">{result.anecdotes.hiddenStory}</p>
                      </div>
                    )}
                  </div>
                )}
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}